var BpiStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ObjectUtils } from "../../utils/object-utils";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../../shared/utils/recipient-utils";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { ApiBuildingPlansInspectorateConstants } from "../../constants/api-constants/api-building-plans-inspectorate.constants";
import { ViewApplicationLocationBpiComponent } from "../../../view-application/modules/bpi/view-application-location-bpi/view-application-location-bpi.component";
import { CreateApplicationLocationBpiComponent } from "../../../create-application/modules/bpi/create-application-location-bpi/create-application-location-bpi.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ErfNumber, "erfNumbers"],
    [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.CreatedDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const BPIExpandListForApplicationPartial = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_BPI;
export var CreateApplicationBpiMenuHeadings;
(function (CreateApplicationBpiMenuHeadings) {
    CreateApplicationBpiMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationBpiMenuHeadings["Location"] = "Property";
    CreateApplicationBpiMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationBpiMenuHeadings["Agent"] = "Agent";
    CreateApplicationBpiMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationBpiMenuHeadings || (CreateApplicationBpiMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Property help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationBpiMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationBpiMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationBpiMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationBpiMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationBpiMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationBpiMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Application status";
    ViewApplicationMenuHeadings["Location"] = "Property";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let BpiStrategyService = class BpiStrategyService extends AflaModuleStrategyService {
    static { BpiStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    applicationCreateService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.BuildingPlansInspectorate;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiBuildingPlansInspectorateConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = BPIExpandListForApplicationPartial;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    savedApplication;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, applicationSearchService, applicationCreateService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.applicationCreateService = applicationCreateService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiBuildingPlansInspectorateConstants.URL}/${ApiBuildingPlansInspectorateConstants.FUNCTION_GET_MY_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationBpiMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, BPIExpandListForApplicationPartial);
    }
    buildListFilter(list, column) {
        const params = BpiStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
            applicationType: application.applicationType,
            applicant: BpiStrategyService_1.getRecipientName(BpiStrategyService_1.getFirstRecipient(application.applicant)),
            agent: BpiStrategyService_1.getRecipientName(BpiStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate),
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationBpiComponent,
            ]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationBpiMenuHeadings.Location,
                CreateApplicationLocationBpiComponent,
            ]
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiBuildingPlansInspectorateConstants.URL}/${ApiBuildingPlansInspectorateConstants.FUNCTION_GET_ALL_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = BpiStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, BpiStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription =
            this.postApplicationService(application).subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(BpiStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                    this.resetForm();
                    this.router.navigate([
                        AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")
                    ]).then();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationBpiMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpiMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpiMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpiMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                bpiApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest property owners
                    const params = {
                        $select: "properties",
                        $expand: "properties($expand=owners($expand=groups))",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            savedApplication.properties = response.value[0]?.properties;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        },
                        complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(BpiStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.bpiApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(BpiStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        application.elodgementStep = step.stepIndex;
        let owners = [];
        if (application.properties && application.properties.length > 0) {
            const propertiesArray = this.form.get("propertiesForm").get("properties");
            propertiesArray.controls.forEach((item) => {
                owners = item.get("owners").value ? item.get("owners").value : [];
                if (owners && owners.length > 0) {
                    owners = owners.map((owner) => {
                        owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                        return owner;
                    });
                }
            });
            application.properties[0].owners = owners;
        }
        this.creatResubmittedApplicationObservable(0, application, continueAfterSave).subscribe({
            next: (savedApplication) => {
                this.previousApplication = null;
                const params = {
                    $expand: this.expandListForApplicationPartial,
                    $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+savedApplication.moduleId}`
                };
                this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                    next: (response) => {
                        savedApplication.properties = response.value[0]?.properties;
                        if (continueAfterSave && !savedApplication.eLodgementComplete) {
                            --savedApplication.eLodgementStep;
                        }
                        this.savedApplication = savedApplication;
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                        this.requestStatusService.removeBusySpinner("continueToNextStep");
                    },
                    complete: () => {
                        if (this.savedApplication && continueAfterSave) {
                            this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                            this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                            this.appController.showMessage(AflaModuleStrategyService.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                        }
                        else {
                            // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                            // this.savedApplication.eLodgementStep = applicationRequestDto.bpApplication.eLodgementStep;
                            this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                            this.appController.showMessage(AflaModuleStrategyService.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                        }
                        this.requestStatusService.removeBusySpinner("continueToNextStep");
                        this.requestStatusService.removeBusySpinner("TrueCentroid");
                    }
                });
            }, error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                this.requestStatusService.removeBusySpinner("continueToNextStep");
            }
        });
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${applicationId}/${ApiBuildingPlansInspectorateConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, application, continueAfterSave) {
        application.bpamsApplicationId = application.id;
        application.id = 0;
        application.bpamsReferenceNumber = application.referenceNumber;
        const requestObject = {
            moveApplicationToNextStepAfterSave: true,
            bpiApplication: application
        };
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${this.appController.selectedModuleID}/${ApiBuildingPlansInspectorateConstants.SAVE_LINKED_APPLICATION}`, requestObject)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationBpiMenuHeadings.Location.toLocaleLowerCase():
                formName = "propertiesForm";
                break;
            case CreateApplicationBpiMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationBpiMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationBpiMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationBpiMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("propertiesForm").get("properties").clear();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationBpiMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationBpiMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationBpiMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    postApplicationService(params) {
        return this.http.post(ApiBuildingPlansInspectorateConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, properties, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationBpiMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationBpiMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiBuildingPlansInspectorateConstants.URL}/${jobId}/GetBpiApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("propertiesForm") && this.form.get("propertiesForm").get("properties")) {
            const propertiesArray = this.form.get("propertiesForm").get("properties");
            if (propertiesArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage("Please select a property before continuing with the create application process", AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage("Please select a property before continuing with the create application process", AlertType.Warning);
            return false;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
                description: new FormControl(null, [Validators.required]),
                applicationType: new FormControl("Building plan inspectorate", [Validators.required]),
                bpamsReferenceNumber: new FormControl(null, [Validators.required]),
                bpamsReferenceLookupType: new FormControl(null),
                erfNumber: new FormControl(null),
                farmNumber: new FormControl(null),
                portionNumber: new FormControl(null),
                allotmentLookup: new FormControl(null),
                hasBpamsReferenceNumber: new FormControl(null, [Validators.required]),
                bpamsApplicationId: new FormControl(null, [Validators.required]),
                isVerified: new FormControl(null, [Validators.required])
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            }),
        });
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        return {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("propertiesForm").get("description").value,
            bpamsReferenceNumber: this.form.get("propertiesForm").get("bpamsReferenceNumber").value,
            bpamsApplicationId: this.form.get("propertiesForm").get("bpamsApplicationId").value,
            applicationType: this.form.get("propertiesForm").get("applicationType").value.value,
            shape: "",
            wkid: 102100,
            applicant: applicant ? [applicant] : [],
            applicantAgent: [],
            properties: [],
            eLodgementComplete: false,
            eLodgementStep: 0
        };
    }
    buildLocationStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.properties = [];
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                properties: [],
                shape: "",
                wkid: 102100,
                bpamsReferenceNumber: this.form.get("propertiesForm").get("bpamsReferenceNumber").value,
                bpamsApplicationId: this.form.get("propertiesForm").get("bpamsApplicationId").value,
                description: this.form.get("propertiesForm").get("description").value,
                applicationType: this.form.get("propertiesForm").get("applicationType").value,
                hasBpamsReferenceNumber: this.form.get("propertiesForm").get("hasBpamsReferenceNumber").value
            };
        // this should cover the copied applicant
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        if (applicantFormValue) {
            const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
            application.applicant = [applicant];
        }
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            let owners = item.get("owners").value ? item.get("owners").value : [];
            if (owners && owners.length > 0) {
                owners = owners.map((owner) => {
                    owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                    return owner;
                });
            }
            const property = {
                id: item.get("id").value,
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                erfSize: item.get("erfSize").value,
                farmNumber: item.get("farmNo").value,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                wkid: 102100,
                owners,
            };
            application.properties.push(property);
        });
        application.shape = `MULTIPOINT (${points.join(", ")})`;
        return application;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = [applicant];
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: [applicant],
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
            };
        return application;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            application.applicantAgentNa = applicantAgentIsNullValue;
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicantAgent: applicantAgent ? [applicantAgent] : [],
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
            };
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return application;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true,
            };
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    createResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        throw new Error("Method not implemented.");
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
BpiStrategyService = BpiStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsubPortal()
], BpiStrategyService);
export { BpiStrategyService };
